<template>
  <div class="px-6 py-4 bg-white">
    <h1 class="text-2xl font-bold text-center text-primary">
      รายงานบุคลากรแบ่งตามความเสี่ยง
    </h1>

    <div class="flex justify-end mt-8">
      <a-button class="w-40" type="primary" @click="exportReport"
        >Export XLS</a-button
      >
    </div>

    <a-tabs class="mt-8" default-active-key="1">
      <a-tab-pane
        v-for="levelSummary in riskSummary"
        :key="levelSummary.riskLevel"
        :tab="`${levelSummary.riskLevel} (${levelSummary.employees.length} คน)`"
      >
        <a-table
          :columns="columns"
          :data-source="levelSummary.employees"
          :pagination="false"
        />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
import collect from "collect.js";
import EventBus from "@/events/event-bus.js";

export default {
  created() {
    this.fetchRiskSummary();

    EventBus.$on("dashboardYearChanged", this.fetchRiskSummary);
    EventBus.$on("dashboardEmployeeTypeChanged", this.fetchRiskSummary);
  },
  beforeDestroy() {
    EventBus.$off("dashboardYearChanged", this.fetchRiskSummary);
    EventBus.$off("dashboardEmployeeTypeChanged", this.fetchRiskSummary);
  },
  data() {
    return {
      riskSummary: {},
      loading: false,
    };
  },
  methods: {
    async fetchRiskSummary() {
      this.loading = true;

      try {
        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_API_URL}/dashboard/risk/employee?year=${this.$store.state.dashboardYear}&employeeType=${this.$store.state.dashboardEmployeeType}`,
          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.riskSummary = response.data;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    exportReport() {
      const riskWorkSheet = XLSX.utils.json_to_sheet(this.spreadsheetReport);

      const workBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workBook, riskWorkSheet, "ความเสี่ยง");

      XLSX.writeFile(
        workBook,
        `รายงานบุคลากรแบ่งตามความเสี่ยง-${Date.now()}.xlsx`
      );
    },
  },
  computed: {
    spreadsheetReport() {
      return collect(this.riskSummary)
        .pluck("employees")
        .flatten(1)
        .map(
          ({
            firstname,
            lastname,
            risk_level,
            gender,
            faculty,
            employee_type,
            email,
            latest_assessment,
          }) => {
            return {
              firstname,
              lastname,
              risk_level,
              gender,
              faculty,
              employee_type,
              email,
              latest_assessment,
            };
          }
        )
        .toArray();
    },
    columns() {
      return [
        {
          title: "ชื่อ",
          dataIndex: "firstname",
          sorter: (a, b) => a.firstname.localeCompare(b.firstname),
          defaultSortOrder: "ascend",
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "หน่วยงาน",
          dataIndex: "faculty",
          sorter: (a, b) => a.faculty.localeCompare(b.faculty),
          defaultSortOrder: "ascend",
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "ประเมินล่าสุด",
          dataIndex: "latest_assessment",
          sorter: (a, b) =>
            a.latest_assessment.localeCompare(b.latest_assessment),
          defaultSortOrder: "ascend",
          sortDirections: ["descend", "ascend"],
        },
      ];
    },
  },
};
</script>
